import React from "react";
import {  RCCGrid, RCCIcon } from "react-common-components";
import Card from "src/components/Card";
import InfiniteScrollWithoutFetch from "src/components/InfiniteScrollWithoutFetch";
import { DivWithWrap } from "src/components/OrgChart/components/ListCardOKR/styles";
import Photo from "src/components/Photo";
import { useTranslation } from "src/context/Translations/context";
import formatDate from "src/utils/formatDate";
import BadgeAnalysis from "../BadgeAnalysis";
import { TypeBadge } from "../ListAnalysis/interface";
import { ICardRisk } from "./interface";
import DivGrouper from "./styles";

const CardRisks: React.FC<ICardRisk> = ({
	data,
	options,
	filter
}) => {
	const { REACT_APP_S3_ADDRESS, REACT_APP_S3_DIRECTORY } = process.env;
	const { translate, currentLanguage } = useTranslation();



	return (
		<>
			<DivGrouper>
				<InfiniteScrollWithoutFetch 
					listElements={data}
					filter={filter}
					mapper={(risk) => (
						<Card
							color="purple"
							options={options(risk)}
							title={`${risk.fullTitle}`}
							hidePercentage
							key={`${risk.rib001Id}`}
						>
							<RCCGrid container item alignItems="center" >
								<DivWithWrap style={{marginRight: "0.5rem"}}>
									<Photo 
										name={risk.eftba005.efa005Nome}
										link={risk.eftba005.efa005Imagem && `${REACT_APP_S3_ADDRESS}/${REACT_APP_S3_DIRECTORY}/imagens_usuarios/${risk.eftba005.efa005Imagem}`}
										hover
									/>
									{risk.eftba005.efa005Nome}
								</DivWithWrap>
								<DivWithWrap style={risk.rib001Data !== null ? { flexDirection: "column", alignItems: "baseline" } : {}}>
									<DivWithWrap>
										<RCCIcon name="calendar" size={16} color="var(--default-color-font)" />
										{formatDate(risk.rib001Data, currentLanguage)}
										<BadgeAnalysis 
											type={TypeBadge.SITUATION}
											value={risk.rib001Situacao}
										/>
									</DivWithWrap>
								</DivWithWrap>	
							</RCCGrid>
							<RCCGrid
								container
								item
								alignItems="center"
								justifyContent="space-between"
							>
								<DivWithWrap>
									<BadgeAnalysis 
										value={risk.rib001Quadrante}
										type={TypeBadge.QUADRANT}
										styleInline="margin: 5px 10px 0px 8px;"
									/>
									{`${translate("Incidentes")}: ${risk.ritbb004Lenght ? risk.ritbb004Lenght : 0}`}
								</DivWithWrap>
							</RCCGrid>
						</Card>	
					)}
				/>	
			</DivGrouper>
		</>
	);
};

export default CardRisks;
